import { render, staticRenderFns } from "./WaggonInfo.component.vue?vue&type=template&id=64174dcc&"
import script from "./WaggonInfo.component.vue?vue&type=script&lang=js&"
export * from "./WaggonInfo.component.vue?vue&type=script&lang=js&"
import style0 from "./WaggonInfo.component.vue?vue&type=style&index=0&id=64174dcc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports